import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import 'hammerjs';
import { Circles } from 'react-loader-spinner';
import axios from '../common/axios';
import { Box,Typography } from '@mui/material';
import ProgressChartWithTitle from './common/schartwithTitle';
import dayjs from 'dayjs';


const ProgressChart = ({ height, width, criteriaDate, selectedProject }) => {

    const [progressData, setProgressData] = useState({});
    const [max, setMax] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
          const date = criteriaDate.format('YYYY-MM-DD');
          try {
            if (selectedProject) {
              const response = await axios.get(`/getoverallprogress?project=${selectedProject}&date=${date}`);
              if (response.data.success) {
                const updatedWeekProgress = response.data.filledWeekProgress.map(item => {
                  const itemDate = dayjs(item.date, 'YY년 WW주');
                  if (itemDate.isAfter(criteriaDate)) {
                    return { ...item, cumulativeEV: null };
                  }
                  return item;
                });
    
                const updatedMonthProgress = response.data.filledMonthProgress.map(item => {
                  const itemDate = dayjs(item.date, 'YY년 MM월');
                  if (itemDate.isAfter(criteriaDate)) {
                    return { ...item, cumulativeEV: null };
                  }
                  return item;
                });
    
                setMax(_.maxBy(updatedWeekProgress, "cumulativePV").cumulativePV);
                setProgressData({ weekProgress: updatedWeekProgress, monthProgress: updatedMonthProgress });
                setLoading(false);
              } else {
                setProgressData({});
                setLoading(false);
              }
            }
          } catch (error) {
            setProgressData({});
            setLoading(false);
            console.error(`데이터 가져오기 중 오류 발생:`, error);
            return []; // 오류 발생 시 빈 배열 반환
          }
        };
        fetchData();
      }, [criteriaDate, selectedProject]);
    

    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center', // 수평 중앙 정렬
                    alignItems: 'center',     // 수직 중앙 정렬
                    height: '100%',           // 부모 컨테이너의 전체 높이 사용
                }}
            >
                <Circles ariaLabel="loading" color="#00BFFF" height={50} width={50} />
            </Box>
        );
    }



        return (
            <ProgressChartWithTitle
                height={height}
                width={width}
                title="Overall Progress"
                chartData={progressData}
                unit="%"
                chart_id="overallprogress"
                maxYaxis={110}
                colors={['#48CAE4','#FEAE65']}
            />
        );
  
};


export default ProgressChart

